import React from 'react';
import {Card, CardBody, CardHeader, CardFooter, Box, Button, Heading, Image, Text} from 'grommet';
import {Clock, Basket, MailOption, Map, Phone, Calendar} from 'grommet-icons';

const ShopList = ({ offers }) => {
    return (
        <Box flex overflow="auto">
            {offers.map(offer => (
                <Card key={offer.id} margin="medium">
                    <CardHeader pad="medium" justify="between">
                        <Heading
                            color={"brand"}
                            size={"small"}
                        >
                            {offer.description}
                        </Heading>
                    </CardHeader>
                    <CardBody pad="small">
                        <Box
                            direction={"column"}
                            gap={"medium"}
                            responsive={true}
                            pad={"medium"}
                        >
                            <Image
                                fit="cover"
                                src={process.env.REACT_APP_BASE_API_URL+"assets/offers/"+offer.imagePath}
                                a11yTitle="bridge"
                            />
                            <Box
                                direction={"row"}
                                gap={"small"}
                            >
                                <Basket
                                    color={"brand"}>
                                </Basket>
                                <Text>
                                    Punti: {Math.ceil(offer.discount)}</Text>
                            </Box>
                            <Box
                                direction={"row"}
                                gap={"small"}
                            >
                                <Calendar
                                    color={"brand"}>
                                </Calendar>
                                <Text
                                >
                                   Validità: {offer.fromDate} - {offer.toDate}
                                </Text>
                            </Box>
                        </Box>
                    </CardBody>
                </Card>
            ))}
        </Box>
    );
};

export default ShopList;
